<n-card-panel class="copy-from-cifs">
    <div slot="title" class="copy-from-switch">
        <h2 class="card-title">{{i18n.title.cifs}}</h2>
        <n-switch id="copy-from-cifs" [(ngModel)]="switch" (onChange)="onSwitchChange($event)">
        </n-switch>
    </div>

    <form *ngIf="switch" [errorMessage]="errorMessage" [formGroup]="vm" class="common-form">
        <!-- 创建模式 -->
        <n-form-item [label]="i18n.label.createStyle" [required]="true" class="create-style">
            <n-radio-group id="copy-from-cifs-share_style" [block]="true" formControlName="CIFScreateStyle"
                (onChange)="onCreateStyleChange($event)">
                <!-- copy from -->
                <n-radio
                    id="copy-from-cifs-share_copyFrom"
                    [value]="CreateStyleE.CopyFrom"
                    [disabled]="isAuditLogFs">
                    <div class="copy-from-select">
                        <span>{{i18n.label.copyFrom}}</span>
                        <div>
                            <!-- 用hideen的原因，是切换的时候ngif会导致选中项丢失,且无法获取到shareSelect -->
                            <n-select [class.hidden]="vm.value.CIFScreateStyle !== CreateStyleE.CopyFrom"
                                [(ngModel)]="copyFromSelection" #CIFSshareSelect id="copy-from-cifs-share_copyFrom_drop"
                                [rest]="shareRest" [valueField]="'ID'" formControlName="CIFScopyFromSelect"
                                [labelField]="'NAME'" [filter]="true" (onChange)="onCopyShareChange($event)">
                            </n-select>
                        </div>
                    </div>
                    <!-- <n-tip *ngIf="!vstoreId&&vm.value.CIFScreateStyle === CreateStyleE.copyFrom"
                        [content]="i18n.tip.plsVstore">
                    </n-tip> -->
                </n-radio>
                <!-- new -->
                <n-radio id="copy-from-cifs-share_new" [value]="CreateStyleE.New">
                    {{i18n.label.new}}
                </n-radio>
            </n-radio-group>
        </n-form-item>

        <!-- 共享 -->
        <n-form-item [label]="i18n.label.share">
            <div class="n-form-item-text">
                <!-- 共享名称 -->
                <!-- vm.value.CIFScreateStyle是指 new 和 copy from，createShare下指定了这两个变量 -->
                <span nTextTips
                    class="share-path">{{createShare[vm.value.CIFScreateStyle].share.NAME || UNPLACEHOLDER}}</span>
                <!-- 逗号 -->
                <span>{{i18n.label.comma}}</span>
                <!-- 权限数-->
                <span>{{getPermissionsNumStr()}}</span>
                <!-- modify 按钮 -->
                <!-- 租户没选的时候，new提示选租户， copyfrom提示选择共享就可以了，因为共享本身依赖租户 -->
                <button nButton [theme]="'text'" class="copy-from-btn" (click)="modifyShare()"
                    [disabled]="(!selectShareOpt && vm.value.CIFScreateStyle === CreateStyleE.CopyFrom) || !this.vstoreId"
                    [disabledTips]="vm.value.CIFScreateStyle === CreateStyleE.CopyFrom ? i18n.tip.plsSlectShare : i18n.tip.plsSelectVstore"
                    [loading]="$getCount">{{i18n.btn.modifyBtn}}</button>
            </div>
        </n-form-item>
    </form>
</n-card-panel>
